export default "__VITE_ASSET__Bk96M1zQ__"